/* Défilement horizontal d'une grille de thés (accueil Prop 2). La piste défile
   nativement : molette, glisser, clavier une fois la piste sélectionnée. Les
   flèches avancent d'une carte et la jauge suit la position. Sans ce script, la
   piste défile toujours à la main et les flèches restent masquées. */
(() => {
  document.querySelectorAll('[data-defilement]').forEach((section) => {
    const piste = section.querySelector('[data-defilement-piste]');
    const nav = section.querySelector('[data-defilement-navigation]');
    if (!piste || !nav) return;
    const precedent = nav.querySelector('[data-defilement-precedent]');
    const suivant = nav.querySelector('[data-defilement-suivant]');
    const jauge = nav.querySelector('[data-defilement-jauge]');
    const reduit = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const pas = () => {
      const carte = piste.firstElementChild;
      if (!carte) return piste.clientWidth;
      const ecart = parseFloat(getComputedStyle(piste).columnGap) || 0;
      return carte.getBoundingClientRect().width + ecart;
    };

    const actualiser = () => {
      const max = piste.scrollWidth - piste.clientWidth;
      nav.hidden = max <= 1;
      precedent.disabled = piste.scrollLeft <= 1;
      suivant.disabled = piste.scrollLeft >= max - 1;
      if (jauge) jauge.style.setProperty('--position', max > 0 ? (piste.scrollLeft / max).toFixed(4) : '0');
    };

    precedent.addEventListener('click', () => piste.scrollBy({ left: -pas(), behavior: reduit() ? 'auto' : 'smooth' }));
    suivant.addEventListener('click', () => piste.scrollBy({ left: pas(), behavior: reduit() ? 'auto' : 'smooth' }));
    piste.addEventListener('scroll', actualiser, { passive: true });
    window.addEventListener('resize', actualiser);
    actualiser();
  });
})();
